import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Button from 'widgets/Button';
import { requestLogin } from 'utils/loginAndRegistration/login';

const Recommend = ({ review, sku, setHelpfulness, customerReviewId, isLoggedIn, router }) => {
  const itIsUsersReview = customerReviewId === review.reviewId;
  const shouldShowNumbers = review.helpfulVotes > 0 || review.unhelpfulVotes > 0;
  const customerHasAlreadyVoted = !!review.customerVote;
  const customerVotedYes = review.customerVote === 'HELPFUL';
  const customerVotedNo = review.customerVote === 'UNHELPFUL';

  if (itIsUsersReview && !shouldShowNumbers) {
    return null;
  }

  return (
    <div className="bop-reviews__recommend">
      <span className="gn-content__paragraph--small bop-reviews__recommend--intro">Was this helpful?</span>
      {(
        <>
          <span
            className={classNames(
              { 'bop-reviews__usersChoice': customerVotedYes },
              { 'bop-reviews__usersReview': itIsUsersReview },
              { 'bop-reviews__helpfulness--inactive': customerHasAlreadyVoted },
              'bop-reviews__recommendationWrapper'
            )}
          >
            <Button
              className="bop-reviews__helpfulness"
              onClick={() => {
                if (isLoggedIn) {
                  setHelpfulness(sku, review.reviewId, true);
                } else {
                  requestLogin(router);
                }
              }}
              disabled={customerHasAlreadyVoted || itIsUsersReview}
            >
              Yes
            </Button>
            <span className="bop-reviews__recommendationNumber">
              {shouldShowNumbers && ` (${review.helpfulVotes})`}
            </span>
          </span>
          <span
            className={classNames(
              { 'bop-reviews__usersChoice': customerVotedNo },
              { 'bop-reviews__usersReview': itIsUsersReview },
              { 'bop-reviews__helpfulness--inactive': customerHasAlreadyVoted },
              'bop-reviews__recommendationWrapper'
            )}
          >
            <Button
              className="bop-reviews__helpfulness"
              onClick={() => {
                if (isLoggedIn) {
                  setHelpfulness(sku, review.reviewId, false);
                } else {
                  requestLogin(router);
                }
              }}
              disabled={customerHasAlreadyVoted || itIsUsersReview}
            >
              No
            </Button>
            <span className="bop-reviews__recommendationNumber">
              {shouldShowNumbers && ` (${review.unhelpfulVotes})`}
            </span>
          </span>
        </>)}
    </div>
  );
};

Recommend.propTypes = {
  customerReviewId: PropTypes.number,
  isLoggedIn: PropTypes.bool.isRequired,
  setHelpfulness: PropTypes.func.isRequired,
  sku: PropTypes.string.isRequired,
  review: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
};

export default Recommend;
